{
  "level": "mt03mv4",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03mv4",
    "objects": "AREAS.E3:mt03mv4.e3",
    "mesh": "TREES.E3:mt03mv4.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: mt3mvd4b",
      "entity_class": "CSlidingDoor",
      "piece_name": "mt3mvd4b",
      "offset": 457,
      "centroid": [
        -991.5,
        -2743.0,
        728.75
      ],
      "bbox_min": [
        -992.5,
        -2762.0,
        720.0
      ],
      "bbox_max": [
        -990.5,
        -2724.0,
        737.5
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 38.0,
        "height_z": 17.5,
        "door_width": 38.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -992.5,
          -2762.0,
          720.0
        ],
        [
          -992.5,
          -2724.0,
          737.5
        ],
        [
          -992.5,
          -2762.0,
          737.5
        ],
        [
          -992.5,
          -2724.0,
          720.0
        ],
        [
          -990.5,
          -2762.0,
          720.0
        ],
        [
          -990.5,
          -2724.0,
          737.5
        ],
        [
          -990.5,
          -2762.0,
          737.5
        ],
        [
          -990.5,
          -2724.0,
          720.0
        ]
      ],
      "plane_distance": -992.5,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: mt3mvd4t",
      "entity_class": "CSlidingDoor",
      "piece_name": "mt3mvd4t",
      "offset": 2101,
      "centroid": [
        -991.5,
        -2743.0,
        746.75
      ],
      "bbox_min": [
        -992.5,
        -2762.0,
        737.5
      ],
      "bbox_max": [
        -990.5,
        -2724.0,
        756.0
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 38.0,
        "height_z": 18.5,
        "door_width": 38.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -992.5,
          -2762.0,
          737.5
        ],
        [
          -992.5,
          -2724.0,
          756.0
        ],
        [
          -992.5,
          -2762.0,
          756.0
        ],
        [
          -992.5,
          -2724.0,
          737.5
        ],
        [
          -990.5,
          -2762.0,
          737.5
        ],
        [
          -990.5,
          -2724.0,
          756.0
        ],
        [
          -990.5,
          -2762.0,
          756.0
        ],
        [
          -990.5,
          -2724.0,
          737.5
        ]
      ],
      "plane_distance": -992.5,
      "authentic_texture": "chkrooftrak_h"
    }
  ],
  "tutorial_messages": []
}